var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscribeBuildingsOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 47,
    viewBox: "0 0 55 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 35.0338V29.959",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 25.7783V20.4053",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.7299V1.86133C5.46675 3.33392 9.9335 4.8065 14.4003 6.27909C15.576 6.67389 16.7547 7.06293 17.9362 7.44621L20.3526 8.2459V46H1V41.0074",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9314 2.67787V7.4328C16.7528 7.04664 15.5742 6.6576 14.3955 6.26568V2.67787C14.4091 2.21999 14.6038 1.78621 14.9369 1.47176C15.27 1.1573 15.7142 0.987878 16.1721 1.00068C16.6271 0.99251 17.0669 1.164 17.3962 1.47797C17.7256 1.79193 17.9179 2.22306 17.9314 2.67787Z",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5544 13.415H5.76361C4.90178 13.415 4.20312 14.1137 4.20312 14.9755V15.1484C4.20312 16.0103 4.90178 16.7089 5.76361 16.7089H15.5544C16.4163 16.7089 17.1149 16.0103 17.1149 15.1484V14.9755C17.1149 14.1137 16.4163 13.415 15.5544 13.415Z",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.572 20.6299H5.78118C4.91935 20.6299 4.2207 21.3285 4.2207 22.1904V22.3633C4.2207 23.2251 4.91935 23.9238 5.78118 23.9238H15.572C16.4338 23.9238 17.1325 23.2251 17.1325 22.3633V22.1904C17.1325 21.3285 16.4338 20.6299 15.572 20.6299Z",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.572 27.7324H5.78118C4.91935 27.7324 4.2207 28.4311 4.2207 29.2929V29.4658C4.2207 30.3276 4.91935 31.0263 5.78118 31.0263H15.572C16.4338 31.0263 17.1325 30.3276 17.1325 29.4658V29.2929C17.1325 28.4311 16.4338 27.7324 15.572 27.7324Z",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2059 39.585C43.2054 40.7927 43.6134 41.9652 44.3637 42.9117C45.114 43.8581 46.1623 44.523 47.3384 44.7981V45.9998H20.3477V12.2139H47.3384V34.3718C46.1623 34.647 45.114 35.3118 44.3637 36.2583C43.6134 37.2047 43.2054 38.3772 43.2059 39.585Z",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6666 7.44629H25.8428V12.2099H42.6666V7.44629Z",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.316 1.00098H32.3867V7.44607H36.316V1.00098Z",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.918 39.5853C53.918 41.0057 53.3537 42.368 52.3493 43.3724C51.3449 44.3768 49.9826 44.9411 48.5622 44.9411C48.1502 44.9423 47.7395 44.8944 47.3389 44.7984C46.164 44.5217 45.1171 43.8563 44.3679 42.9101C43.6186 41.9638 43.2109 40.7923 43.2109 39.5853C43.2109 38.3783 43.6186 37.2068 44.3679 36.2605C45.1171 35.3143 46.164 34.6489 47.3389 34.3722C47.7395 34.2762 48.1502 34.2283 48.5622 34.2295C49.9826 34.2295 51.3449 34.7938 52.3493 35.7982C53.3537 36.8026 53.918 38.1649 53.918 39.5853Z",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6602 39.585H50.6284",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5752 37.6006V41.5688",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4219 16.7871H30.7877",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9297 16.71H44.2955",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4043 23.2588H30.7744",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9121 23.1855H44.2822",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4043 29.8018H30.7744",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4043 35.1924H30.7744",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9121 29.7285H44.2822",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribeBuildingsOverview);
export default __webpack_public_path__ + "static/media/subscribe-buildings-overview.4f662adafe610164a63519e0f2667158.svg";
export { ForwardRef as ReactComponent };